import router from '../../router'

export interface State {
  profile: {
    cover_image: {
      id: string
      url: string
    }
    email: string
    id: string

    name: string
    password_registered_at: string
    portrait_image: {
      id: string
      url: string
    }
    screen_name: string
    twitter_id?: string
  } | null
  isProfileLoading: boolean
}

export interface Context {
  commit: (name: string, payload: object) => void
  dispatch: (name: string, payload?: any, options?: any) => void
}

export interface Mutations {
  [key: string]: (state: State, payload?: any) => void
}

export interface Actions {
  [key: string]: (this: any, context: Context, payload?: any) => void
}

export const initialState: State = {
  profile: null,
  isProfileLoading: false
}

export const mutations: Mutations = {
  setProfile(state, payload) {
    state.profile = payload.profile
  },
  onProfileLoadingStart(state) {
    state.isProfileLoading = true
  },
  onProfileLoadingFinished(state) {
    state.isProfileLoading = false
  }
}

export const actions: Actions = {
  async fetchProfile({ commit }, payload) {
    commit('onProfileLoadingStart', {})
    const { response, error } = await this.$api.fetchUsersMe()
    if (response) {
      commit('setProfile', response)
      await this.$delay(500)
      commit('onProfileLoadingFinished', {})
      return
    }
    await this.$delay(500)
    commit('onProfileLoadingFinished', {})
  },
  async postUpdateProfile({ commit, dispatch }, payload) {
    commit('onProfileLoadingStart', {})
    const { response, error } = await this.$api.postUpdateProfile(payload)
    if (response) {
      await this.$delay(500)
      router.push('/settings')
      commit('onProfileLoadingFinished', {})
      dispatch(
        'flash/setMessage',
        {
          message: '変更を保存しました',
          isAlert: false
        },
        {
          root: true
        }
      )
      return
    }
    await this.$delay(500)
    commit('onProfileLoadingFinished', {})
  },
  async postUpdateEmail({ commit, dispatch }, payload) {
    commit('onProfileLoadingStart', {})
    const { response, error } = await this.$api.postUpdateEmail(payload)
    if (response) {
      await this.$delay(500)
      router.push('/settings')
      commit('onProfileLoadingFinished', {})
      dispatch(
        'flash/setMessage',
        {
          message: '変更を保存しました',
          isAlert: false
        },
        {
          root: true
        }
      )
      return
    }
    await this.$delay(500)
    commit('onProfileLoadingFinished', {})
  },
  async postUpdatePassword({ commit, dispatch }, payload) {
    commit('onProfileLoadingStart', {})
    const { response, error } = await this.$api.postUpdatePassword(payload)
    if (error) {
      await this.$delay(500)
      commit('onProfileLoadingFinished', {})
      return
    }

    await this.$delay(500)
    router.push('/settings')
    commit('onProfileLoadingFinished', {})
    dispatch(
      'flash/setMessage',
      {
        message: '変更を保存しました',
        isAlert: false
      },
      {
        root: true
      }
    )
  }
}

export default {
  namespaced: true,
  state: () => initialState,
  mutations,
  actions
}
